/**
 * Real variant UI helpers for product-variant-picker-diamond:
 * - Carat Size shape icons follow Diamond Shape fake attr (`pfa:shape-change`)
 * - Center Diamond label stays in sync with Carat + Quality
 */
(() => {
  function formatQualityDisplay(value) {
    if (!value) return '';
    const parts = String(value)
      .split('-')
      .map((p) => p.trim())
      .filter(Boolean);
    if (parts.length >= 2) return `${parts[0]} ${parts[1]}`;
    return value;
  }

  function updateCenterSpec(root) {
    const spec = root.querySelector('[data-pdo-center-spec]');
    if (!spec) return;
    const caratField = root.querySelector('[data-pdo-carat]');
    const qualityField = root.querySelector('[data-pdo-quality]');
    const carat =
      caratField?.querySelector('input[type="radio"]:checked')?.dataset.displayValue ||
      caratField?.querySelector('input[type="radio"]:checked')?.value ||
      '';
    const qualityInput = qualityField?.querySelector('input[type="radio"]:checked');
    const quality =
      qualityInput?.dataset.displayValue ||
      formatQualityDisplay(qualityInput?.value || '');
    const parts = [carat, quality].filter(Boolean);
    spec.textContent = parts.join(' ');
  }

  function applyShapeIcons(root, imageUrl) {
    if (!imageUrl) return;
    root.querySelectorAll('[data-pdo-shape-icon]').forEach((icon) => {
      const size =
        icon.closest('[data-pdo-icon-size]')?.dataset.pdoIconSize ||
        icon.getAttribute('width') ||
        28;
      if (icon.tagName === 'IMG') {
        icon.src = imageUrl;
        icon.style.width = `${size}px`;
        icon.style.height = `${size}px`;
      } else {
        const img = document.createElement('img');
        img.className = 'product-diamond-options__shape-icon';
        img.src = imageUrl;
        img.alt = '';
        img.loading = 'lazy';
        img.width = size;
        img.height = size;
        img.style.width = `${size}px`;
        img.style.height = `${size}px`;
        img.setAttribute('data-pdo-shape-icon', '');
        icon.replaceWith(img);
      }
    });
  }

  function initRoot(root) {
    if (root.dataset.pdoReady === 'true') return;
    root.dataset.pdoReady = 'true';

    const sectionId = root.dataset.section;

    root.addEventListener('change', () => updateCenterSpec(root));
    updateCenterSpec(root);

    document.addEventListener('pfa:shape-change', (event) => {
      const detail = event.detail || {};
      if (detail.sectionId && sectionId && detail.sectionId !== sectionId) return;
      applyShapeIcons(root, detail.imageUrl);
    });
  }

  function boot() {
    document.querySelectorAll('variant-selects.product-variant-picker-diamond').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
